import * as React from 'react';
import classNames from 'classnames';
import Title from './Title';
import Grid from './Grid';
import Paragraph from './Paragraph';
import { getPrefixCls } from '../configure';
import Element from './Element';
function getComponentProps(prop) {
    if (prop && typeof prop === 'object') {
        return prop;
    }
    return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) {
        // Square avatar
        return { size: 'large', shape: 'square' };
    }
    return { size: 'large', shape: 'circle' };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) {
        return { width: '38%' };
    }
    if (hasAvatar && hasParagraph) {
        return { width: '50%' };
    }
    return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) {
        basicProps.width = '61%';
    }
    // Rows
    if (!hasAvatar && hasTitle) {
        basicProps.rows = 3;
    }
    else {
        basicProps.rows = 2;
    }
    return basicProps;
}
class Skeleton extends React.Component {
    constructor() {
        super(...arguments);
        this.renderSkeleton = () => {
            const { prefixCls: customizePrefixCls, loading, className, children, avatar, title, paragraph, active, grid, } = this.props;
            const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
            if (loading || !('loading' in this.props)) {
                const hasAvatar = !!avatar;
                const hasTitle = !!title;
                const hasParagraph = !!paragraph;
                const hasGrid = !!grid;
                // Avatar
                let avatarNode;
                if (hasAvatar) {
                    const avatarProps = {
                        prefixCls: `${prefixCls}-avatar`,
                        ...getAvatarBasicProps(hasTitle, hasParagraph),
                        ...getComponentProps(avatar),
                    };
                    // We direct use SkeletonElement as avatar in skeleton internal.
                    avatarNode = (React.createElement("div", { className: `${prefixCls}-header` },
                        React.createElement(Element, Object.assign({}, avatarProps))));
                }
                let contentNode;
                if (hasTitle || hasParagraph || hasGrid) {
                    // Title
                    let $title;
                    if (hasTitle) {
                        const titleProps = {
                            prefixCls: `${prefixCls}-title`,
                            ...getTitleBasicProps(hasAvatar, hasParagraph || hasGrid),
                            ...getComponentProps(title),
                        };
                        $title = React.createElement(Title, Object.assign({}, titleProps));
                    }
                    // Paragraph
                    let paragraphNode;
                    if (hasParagraph) {
                        const paragraphProps = {
                            prefixCls: `${prefixCls}-paragraph`,
                            ...getParagraphBasicProps(hasAvatar, hasTitle),
                            ...getComponentProps(paragraph),
                        };
                        paragraphNode = React.createElement(Paragraph, Object.assign({}, paragraphProps));
                    }
                    // Grid
                    let gridNode;
                    if (hasGrid) {
                        const gridProps = {
                            prefixCls: `${prefixCls}-grid`,
                            ...getComponentProps(grid),
                        };
                        gridNode = React.createElement(Grid, Object.assign({}, gridProps));
                    }
                    contentNode = (React.createElement("div", { className: `${prefixCls}-content` },
                        $title,
                        paragraphNode,
                        gridNode));
                }
                const cls = classNames(prefixCls, className, {
                    [`${prefixCls}-with-avatar`]: hasAvatar,
                    [`${prefixCls}-active`]: active,
                    [`${prefixCls}-rtl`]: false,
                });
                return (React.createElement("div", { className: cls },
                    avatarNode,
                    contentNode));
            }
            return children;
        };
    }
    render() {
        return React.createElement(React.Fragment, null, this.renderSkeleton());
    }
}
Skeleton.defaultProps = {
    avatar: false,
    title: true,
    paragraph: true,
};
export default Skeleton;
